import { useScanPolling } from '@/hooks/useScanPolling'

interface ScanProgressTrackerProps {
  scanId: string
  onUpdate: (scanId: string, progress: number, status: string, security_score?: number, vulnerabilities_count?: number, queue_position?: number, estimated_wait_minutes?: number) => void
  onComplete: (scanId: string) => void
  onError?: (scanId: string, error: string) => void
  toast?: (options: {
    title: string
    description?: string
    variant?: "default" | "success" | "destructive" | "confirmation"
  }) => void
}

/**
 * Component that tracks progress for a single scan
 * This is a separate component to properly use the useScanPolling hook
 */
export function ScanProgressTracker({ scanId, onUpdate, onComplete, onError, toast }: ScanProgressTrackerProps) {
  useScanPolling({
    scanId,
    enabled: true,
    onUpdate: (status) => {
      onUpdate(
        scanId,
        status.progress,
        status.status,
        status.security_score,
        status.vulnerabilities_count,
        status.queue_position,
        status.estimated_wait_minutes
      )
    },
    onComplete: () => {
      onComplete(scanId)
    },
    onError: (error) => {
      console.error(`Error polling scan ${scanId}:`, error)
      // Call onError callback if provided (for handling deleted scans)
      onError?.(scanId, error)
    },
    toast
  })

  return null // This component doesn't render anything
}
